/**
 *  Concatenar num ocorrências de chr a esquerda
 */
export default function (valor, num, chr) {
 let tam = valor.length
 let nstr = ''
 let i

 if(num < tam)
  return valor

 for(i = tam; i < num; i++)
  nstr = nstr.concat(chr)
 
 return nstr.concat(valor)
}
